export const environment = {
  production: true,
  authority: 'https://signin.dev-connect.aveva.com',
  clientId: 'KImPvO5uTkZLRiKgNV66K52WBEd5rLQe',
  singleSignOutUrl: 'https://profile.capdev-connect.aveva.com/singlesignout',
  sessionExpiredUrl: 'https://profile.capdev-connect.aveva.com/sessionexpired',
  userProfileManagementUrl: 'https://profile.capdev-connect.aveva.com/myprofile/details',
  connect: 'https://capdev-connect.aveva.com',
  apis: {
    am: 'https://api.capdev-connect.aveva.com/am',
    registry: 'https://api.capdev-connect.aveva.com/registry',
    uam: 'https://services.capdev-connect.aveva.com/uam/v2',
    scm: 'https://api.capdev-connect.aveva.com/scm',
    logging: 'https://api.capdev-connect.aveva.com/logging',
    assets: 'https://api.capdev-connect.aveva.com/assets',
    ermDevOps: 'https://api.dev-erm.capdev-connect.aveva.com/devops'
  },
  erm: {
    ermDevOpsConnectAccountId: '348aaebc-499c-4ad1-a2bd-9a16de71f6e8'
  }
};